import { createApp } from 'vue'
import App from './App.vue'
import './assets/tailwind.css'
import 'tailwindcss-gradients'
import './assets/css/style.css'
import 'vue-scrollto'
import 'tailwind-scroll-behavior'
import router from './router'

import VueKinesis from "vue-kinesis";
import VueParticles from 'vue-particles';
import { VueReCaptcha } from 'vue-recaptcha-v3';
import VueSweetalert2 from 'vue-sweetalert2';
import 'sweetalert2/dist/sweetalert2.min.css';

createApp(App).use(router).use(VueParticles).use(VueSweetalert2).use(VueKinesis).use(VueReCaptcha, {
    siteKey: '6LeswmofAAAAAKLsTvZyU8hGO7fOaZ1CGjbO88BE',
    loaderOptions: {
        useRecaptchaNet: true
    }
}).mount('#app')

